export default __webpack_public_path__ + "static/maxqda-e27fb96a98aaecd462d3471a01b8fe05.png";